import React from "react";

import { IFileData } from "@selas/models";
import { Trans } from "react-i18next";

interface IProps {
	file: IFileData;
}

const FileViewer: React.FC<IProps> = (props: IProps) => {
	const url: string = "/api/files/" + props.file.internalFilename + "/" + props.file.filename;
	if (props.file.type.startsWith("image/")) {
		return <img className="fileviewer-image" src={url} alt={props.file.filename} />;
	} else if (props.file.type === "application/pdf") {
		return <iframe className="h-100 w-100 fileviwer-pdf" src={url} title="pdf" />;
	}
	return (
		<div className="fileviewer-unknownType">
			<Trans i18nKey="unable_to_display">
				Unable to display.
				<br />
				Download <a href={url + "?download=true"}>here</a>.
			</Trans>
		</div>
	);
};

export default FileViewer;
